import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=671a9fde&scoped=true"
import script from "./CustomCard.vue?vue&type=script&lang=ts"
export * from "./CustomCard.vue?vue&type=script&lang=ts"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=671a9fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a9fde",
  null
  
)

export default component.exports